import { FileResponse, ProductDocumentModel } from '../../../../app/services/api/ofdClient';

export const uploadFile = (
  documentId: number,
  productId: number,
  file: File,
  setDocument: React.Dispatch<React.SetStateAction<ProductDocumentModel>>,
) => {
  if (!file) return;

  const reader = new FileReader();

  reader.onloadend = () => {
    const fileData = reader.result ? reader.result.toString().replace(/^data:(.*,)?/, '') : '';

    setDocument({
      id: documentId,
      productId: productId,
      fileName: file.name,
      fileType: file.type,
      fileDataBase64: fileData,
    });
  };
  reader.readAsDataURL(file);
};

export const downloadFile = async (
  documentId: number,
  downloadProductDocument: (documentId: number) => Promise<FileResponse>,
) => {
  try {
    const response = await downloadProductDocument(documentId);

    if (!(response.data instanceof Blob)) {
      throw new Error('Invalid file data received');
    }

    let filename = 'product_document'; // Fallback filename
    const contentDisposition = response.headers?.['content-disposition'];

    if (contentDisposition) {
      const match = contentDisposition.match(/filename\*?=(?:UTF-8''|")(.*?)(?:;|$|")/);
      if (match && match[1]) {
        filename = decodeURIComponent(match[1]);
      }
    }

    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  } catch (result) {
    console.error(result);
  }
};

export const formatDate = (dateString?: string, excludeTime?: boolean) => {
  if (!dateString) return '';

  const [datePart, timePart = '00:00:00'] = dateString.split(' ');

  const [day, month, year] = datePart.split('/');
  const [hour = '00', minute = '00'] = timePart.split(':');

  const formattedDate = `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;

  if (excludeTime) {
    return formattedDate;
  }

  return `${formattedDate} ${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
};

